export default __webpack_public_path__ + "static/media/person_section.588521d7.webp";